import script from "./PaperMaker.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperMaker.vue?vue&type=script&setup=true&lang=js"

import "./PaperMaker.vue?vue&type=style&index=0&id=0aeacc40&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aeacc40"]])

export default __exports__